// PendingQuestionsList.js
import React, { useContext, useEffect, useState } from 'react';
import { Table, Tag, Button, Card } from 'antd';
import axios from 'axios';
import { AuthContext } from '../components/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

const url = new URL(window.location.href);
const finalUrl = `/api/`;

const PendingQuestionsList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleRowClick = (record) => {
    return {
      onClick: (event) => {
        if (!event.target.closest('a, button, .ant-dropdown-trigger')) {
          navigate(`/pending-questions/${record.id}`);
        }
      },
      style: {
        cursor: 'pointer',
        transition: 'background-color 0.3s',
      },
      onMouseEnter: (event) => {
        event.currentTarget.style.backgroundColor = '#fafafa';
      },
      onMouseLeave: (event) => {
        event.currentTarget.style.backgroundColor = 'inherit';
      },
    };
  };

  const columns = [
    {
      title: 'Question Title',
      dataIndex: 'question_title',
      render: (text, record) => (
        // <a href={`/pending-questions/${record.id}`}>{text}</a>
        <Link to={`/pending-questions/${record.id}`}>{text}</Link>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (status) => (
        <Tag
          color={
            status === 'pending'
              ? 'orange'
              : status === 'approved'
                ? 'green'
                : 'red'
          }
        >
          {status.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: 'Submission Time',
      dataIndex: 'submit_time',
      render: (time) => new Date(time).toLocaleString(),
    },
    {
      title: 'Exam Board',
      dataIndex: 'exam_board',
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const params =
          user.role === 'manager'
            ? { role: 'reviewer', userId: user.id }
            : { role: 'submitter', userId: user.id };

        const res = await axios.get(finalUrl.concat('pending-questions'), {
          params,
        });
        setData(res.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [user.id, user.role]);

  return (
    <Card title="Pending Questions for Approval" bordered={false}>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="id"
        pagination={{ pageSize: 8 }}
        onRow={handleRowClick}
        rowClassName="hover-row"
      />
    </Card>
  );
};

export default PendingQuestionsList;
